import { jsx as E } from "react/jsx-runtime";
import { Elements as S } from "../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { centsToUnits as x } from "@systemeio/ui";
import { PricePlanTypeEnum as _ } from "../../libs/types/dist/index9.mjs";
import { useMemo as d } from "react";
import { useStore as v, useOfferStore as P } from "../../store/index.mjs";
import { zeroDecimalCurrencies as U } from "./constants/zero-decimal-currencies.mjs";
import { useStripeProvider as b } from "./stripe-provider.mjs";
import { StripePaymentMethodUsingPaymentElementEnum as i } from "./enum/stripe-payment-method-using-payment-element-enum.mjs";
import { IntentTypeEnum as e } from "./enum/intent-type-enum.mjs";
import { useDesignContext as B } from "../../providers/use-design-provider.mjs";
import { getColors as D } from "../../themes/utils/color-utils.mjs";
function N({ children: g, paymentMethodType: t }) {
  var f;
  const { stripePromise: y } = b(), { locale: m } = v(), { currency: n, finalAmount: o, pricePlan: r } = P(), { state: C } = B(), { primaryColor: u, textColorSecondary: p, secondaryColor: a } = D(C), s = d(() => o ? t === i.Klarna && (r == null ? void 0 : r.type) !== _.one_shot && (r != null && r.recurringOptions.trialPeriod) ? e.setup : t === i.Ideal || t === i.Bancontact ? e.setup : e.payment : e.setup, [o, t, (f = r == null ? void 0 : r.recurringOptions) == null ? void 0 : f.trialPeriod, r == null ? void 0 : r.type]), c = d(() => {
    if (!n) return;
    const l = {
      payment_method_types: [t],
      setupFutureUsage: "off_session",
      currency: n,
      locale: m,
      appearance: {
        variables: {
          colorPrimary: u,
          colorBackground: a,
          colorText: p
        }
      }
    };
    if (s === e.setup)
      return {
        ...l,
        mode: s
      };
    {
      if (!o) return;
      const O = U.includes(n) ? x(o) : o;
      return {
        ...l,
        paymentMethodCreation: "manual",
        mode: s,
        amount: O
      };
    }
  }, [
    n,
    o,
    m,
    s,
    t,
    u,
    a,
    p
  ]);
  return c && /* @__PURE__ */ E(S, { stripe: y, options: c, children: g });
}
export {
  N as StripeElementsProvider
};
